import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=31fbc9fc&"
import script from "./UserPanel.vue?vue&type=script&lang=ts&"
export * from "./UserPanel.vue?vue&type=script&lang=ts&"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=31fbc9fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports